import { Button, TextField } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import React from 'react';
import { useClientStyles } from '../../muiStyles/Clients.mui';
import CustomAlerts from '../alerts/CustomAlerts';

const AddNewClientJsx = ({
	alertModal,
	snackbar,
	setSnackbar,
	setViewLeads,
	setShow,
	clientEmail,
	clientName,
	clientPhoneNumber,
	onChange,
}) => {
	const classes = useClientStyles();

	return (
		<div>
			{alertModal && (
				<CustomAlerts
					alertType='warning'
					alertMsg={alertModal}
					setSnackbar={setSnackbar}
					snackbar={snackbar}
				/>
			)}

			<TextField
				className={classes.textField}
				label='Email'
				name='clientEmail'
				autoComplete={'off'}
				type='text'
				value={clientEmail}
				onChange={(e) => onChange(e)}
				variant='outlined'
			/>

			<TextField
				className={classes.textField}
				label='Full Name'
				name='clientName'
				autoComplete={'off'}
				type='text'
				value={clientName}
				onChange={(e) => onChange(e)}
				variant='outlined'
			/>

			<TextField
				className={classes.textField}
				label='Phone Number (1231231234)'
				name='clientPhoneNumber'
				autoComplete={'off'}
				value={clientPhoneNumber}
				onChange={(e) => onChange(e)}
				variant='outlined'
			/>

			{/* Removed for glenridge */}
			{/* <Button
				variant='outlined'
				color='primary'
				onClick={() => {
					setViewLeads(true);
					setShow(false);
				}}
			>
				View Leads
			</Button> */}
		</div>
	);
};

export default AddNewClientJsx;
